var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"kdbSAbBmpaeHVtUJTtxIC"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'
// import { nodeProfilingIntegration } from '@sentry/profiling-node'

import Project from '../package.json'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  release: `orchestrator-ui@${Project.version}+${Project.build}`,
  authToken: process.env.SENTRY_AUTH_TOKEN,

  // Add optional integrations for additional features
  integrations: [
    new Sentry.Replay({
      // Only capture fetch requests that return status code greater than 403
      beforeAddRecordingEvent: event => {
        if (event?.data?.payload?.data?.statusCode >= 403) {
          return event
        }
        return null
      },
      maskAllText: true,
      blockAllMedia: true,
      maskAllInputs: true,
    }),
    new Sentry.BrowserProfilingIntegration(),
    // nodeProfilingIntegration(),
  ],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'staging' ? 0.1 : 0.75,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'staging' ? 0.0 : 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'staging' ? 1.0 : 0.1,

  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // result in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'staging' ? 0.05 : 0.75,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === 'staging',

  // Can be used to suppress logs
  silent: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT !== 'staging',
})
